function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeaderIconLocation = function SvgHeaderIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    viewBox: "0 0 32 42"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M897 185.986a.983.983 0 0 1-.678-.269c-.625-.6-15.311-14.743-15.311-26.462 0-8.412 7.173-15.257 15.989-15.257s15.988 6.845 15.988 15.257c0 11.719-14.684 25.866-15.309 26.462a.983.983 0 0 1-.679.269Zm0-40.156c-7.757 0-14.069 6.023-14.069 13.425 0 9.586 11.17 21.55 14.069 24.491 2.9-2.941 14.068-14.9 14.068-24.491-.003-7.402-6.313-13.425-14.068-13.425Zm0 21.809a8.392 8.392 0 1 1 8.785-8.384 8.6 8.6 0 0 1-8.785 8.384Zm0-14.934a6.558 6.558 0 1 0 6.865 6.55 6.72 6.72 0 0 0-6.865-6.55Z",
    style: {
      fill: "#f7f6f6",
      fillRule: "evenodd"
    },
    transform: "translate(-881 -144)"
  }));
};
export default SvgHeaderIconLocation;